/**
 * Home, chapter 06 — "Let's build the whole thing": the way out.
 *
 * The split once more, closing instead of opening: the halves come
 * together as it scrolls in, the hero rises onto his roof and draws
 * himself, the banner and the way out land last. Fully closed when the
 * section reaches the top of the screen. The markup is the server's
 * (templates/site/sections/home/finale.html.twig).
 *
 * @module sections/home/finale
 */

import { REDUCED_MOTION } from '../../config.js';
import { gsap } from '../../lib/gsap.js';

/**
 * Easter egg: the first tower of the skyline lights the bat-signal while the
 * mouse is on it; a tap switches it on and off on a touch screen. The
 * stylesheet plays it (split.scss), still under reduced motion.
 *
 * @param {HTMLElement} root
 */
function watchBatSignal(root) {
    const tower = root.querySelector('.batsignal__tower');
    const sky = tower?.ownerSVGElement;

    if (!sky) {
        return;
    }

    const light = (on) => sky.classList.toggle('is-lit', on);

    tower.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') {
            light(true);
        }
    });
    tower.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') {
            light(false);
        }
    });
    tower.addEventListener('pointerup', (event) => {
        if (event.pointerType !== 'mouse') {
            light(!sky.classList.contains('is-lit'));
        }
    });
}

/**
 * @param {HTMLElement} root
 */
export function animate(root) {
    watchBatSignal(root);

    if (REDUCED_MOTION) {
        return;
    }

    const timeline = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: { trigger: root, start: 'top bottom', end: 'top top', scrub: true },
    });

    const add = (targets, from, to, at) => {
        if (targets && !(targets instanceof NodeList && targets.length === 0)) {
            timeline.fromTo(targets, from, to, at);
        }
    };

    add(
        root.querySelector('[data-half="front"]'),
        { xPercent: -100 },
        { xPercent: 0, duration: 0.6, ease: 'power2.out' },
        0,
    );
    add(
        root.querySelector('[data-half="back"]'),
        { xPercent: 100 },
        { xPercent: 0, duration: 0.6, ease: 'power2.out' },
        0,
    );
    add(root.querySelector('[data-hero]'), { yPercent: 100 }, { yPercent: 0, duration: 0.45, ease: 'power2.out' }, 0.3);
    add(root.querySelectorAll('.hoodie__stroke'), { drawSVG: '0%' }, { drawSVG: '100%', duration: 0.4 }, 0.5);
    add(
        root.querySelectorAll('[data-cap] .caption__line > span'),
        { yPercent: 110 },
        { yPercent: 0, duration: 0.2, stagger: 0.05 },
        0.6,
    );
    add(
        root.querySelector('[data-banner-inner]'),
        { scale: 0.4, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.15 },
        0.75,
    );
    add(root.querySelector('[data-split-cta]'), { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.15 }, 0.85);
}
